import Seo from "@/components/Seo";
import { IMG, BRAND } from "@/data/mockData";
import SectionHeading from "@/components/SectionHeading";
import { Link } from "react-router-dom";

const VALUES = [
  { t: "Purity", b: "Only 925 sterling and 999 fine silver. Every piece hallmarked." },
  { t: "Craft", b: "Hand-finished by karigars trained across three generations." },
  { t: "Care", b: "Considered pricing, honest advice, lifelong service." },
];

export default function About() {
  return (
    <div data-testid="page-about" className="pt-32 pb-24">
      <Seo path="/about" title="About Us" description="SIRIJA is a family-run silver jewellery house in Raviwar Peth, Pune — where timeless tradition meets contemporary craft." />
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl">
          <div className="overline">About SIRIJA</div>
          <h1 className="mt-6 font-serif font-light text-5xl lg:text-7xl leading-[1] tracking-tight">
            A house of silver. <span className="italic silver-shimmer">Made in Pune.</span>
          </h1>
          <p className="mt-8 text-[16px] leading-relaxed text-[#2E2E2E]/75 font-light">
            SIRIJA is a destination for premium silver jewellery where timeless traditions meet contemporary elegance. From daily wear to bridal collections, festive jewellery, gifting solutions and custom creations — every piece is selected with exceptional attention to quality and craftsmanship.
          </p>
          <p className="mt-6 text-[16px] leading-relaxed text-[#2E2E2E]/75 font-light">
            Our mission is to make fine silver jewellery accessible for every generation while preserving the beauty of Indian artistry.
          </p>
        </div>
      </div>

      <div className="mt-20 grid grid-cols-1 lg:grid-cols-12 gap-6 max-w-7xl mx-auto px-6 lg:px-8">
        <div className="lg:col-span-8 aspect-[16/10] rounded-2xl overflow-hidden"><img src={IMG.store} alt="Showroom" className="w-full h-full object-cover" /></div>
        <div className="lg:col-span-4 aspect-[16/10] lg:aspect-auto rounded-2xl overflow-hidden"><img src={IMG.necklace1} alt="Silver necklace" className="w-full h-full object-cover" /></div>
      </div>

      <section className="mt-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <SectionHeading overline="Our values" title="Three quiet promises we keep." />
          <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-8">
            {VALUES.map((v, i) => (
              <div key={v.t} data-testid={`about-value-${i}`} className="p-8 rounded-2xl border border-[#EDEDED] bg-[#F8F9FA]">
                <div className="overline text-[#A0A0A0]">Value {String(i + 1).padStart(2, "0")}</div>
                <h3 className="mt-4 font-serif text-3xl tracking-tight">{v.t}</h3>
                <p className="mt-4 text-sm text-[#2E2E2E]/75 leading-relaxed">{v.b}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="mt-24 py-24 bg-[#1A1A1A] text-white">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <div className="overline text-white/50">Come, meet us</div>
          <h2 className="mt-4 font-serif font-light text-4xl lg:text-5xl tracking-tight">
            {BRAND.address}
          </h2>
          <p className="mt-6 text-white/70">Call {BRAND.phone} · GSTIN {BRAND.gstin}</p>
          <div className="mt-10">
            <Link to="/contact" data-testid="about-contact-cta" className="btn-fill h-12 px-7 rounded-full bg-white text-[#1A1A1A] text-xs uppercase tracking-[0.2em] inline-flex items-center hover:text-white">Get in touch</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
